import { useMutation, useQuery } from "@tanstack/react-query";
import { apiFetch } from "@/lib/api";

export interface DraftResponse {
  question_id: number;
  response: unknown;
  updated_at: string;
}

export function useGetDrafts(attemptId: number | null) {
  return useQuery<DraftResponse[]>({
    queryKey: ["drafts", attemptId],
    queryFn: () => apiFetch<DraftResponse[]>(`/attempts/${attemptId}/drafts`),
    enabled: !!attemptId,
    staleTime: Infinity,
  });
}

export function useSaveDraft() {
  return useMutation<
    DraftResponse,
    Error,
    { attemptId: number; questionId: number; response: unknown }
  >({
    mutationFn: ({ attemptId, questionId, response }) =>
      apiFetch<DraftResponse>(
        `/attempts/${attemptId}/drafts/${questionId}`,
        {
          method: "PUT",
          body: JSON.stringify({ response }),
        },
      ),
  });
}
